<h2 mat-dialog-title>{{ isEdicao ? 'Editar' : 'Adicionar' }} Usuário</h2>

<mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" fxLayoutGap="10px" style="margin: 0 10px 10px 10px">
    <mat-form-field appearance="outline">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" required aria-label="Username do usuário" />
      <mat-error *ngIf="form.get('username')?.hasError('required')">Username é obrigatório</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome" required aria-label="Nome do usuário" />
      <mat-error *ngIf="form.get('nome')?.hasError('required')">Nome é obrigatório</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput formControlName="email" type="email" required aria-label="E-mail do usuário" />
      <mat-error *ngIf="form.get('email')?.hasError('required')">E-mail é obrigatório</mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('email')">E-mail inválido</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Matrícula</mat-label>
      <input matInput formControlName="matricula" required aria-label="Matrícula do usuário" />
      <mat-error *ngIf="form.get('matricula')?.hasError('required')">Matrícula é obrigatória</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Código Unidade</mat-label>
      <input matInput formControlName="codigoUnidade" required aria-label="Código da unidade" />
      <mat-error *ngIf="form.get('codigoUnidade')?.hasError('required')">Código de unidade é obrigatório</mat-error>
    </mat-form-field>

    <ng-container *ngIf="isEdicao">
      <mat-divider style="margin: 8px 0 16px"></mat-divider>
      <h3 style="margin: 0 0 8px; font-size: 14px; font-weight: 500; color: #666">Gerenciar Papéis</h3>
    </ng-container>

    <div *ngIf="isProprioUsuario" class="alerta-proprio-usuario">
      <mat-icon>info</mat-icon>
      <span>Você não pode alterar seus próprios dados ou papéis.</span>
    </div>

    <div *ngIf="isEdicao && data.usuario?.papeis?.length" style="margin-bottom: 8px">
      <label style="font-size: 12px; color: #666">Papéis atuais:</label>
      <div fxLayout="row wrap" fxLayoutGap="8px" style="margin-top: 8px">
        <span *ngFor="let p of data.usuario!.papeis" class="papel-chip" [matTooltip]="getPapelDescricao(p.nome)">
          {{ p.nome }}
        </span>
      </div>
    </div>

    <mat-form-field appearance="outline" *ngIf="!isProprioUsuario">
      <mat-label>{{ isEdicao ? 'Adicionar novo papel' : 'Papel' }}</mat-label>
      <mat-select formControlName="papel" aria-label="Papel do usuário">
        <mat-option *ngFor="let p of papeis" [value]="p.value">{{ p.label }}</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('papel')?.hasError('required')">Papel é obrigatório</mat-error>
    </mat-form-field>

    <div *ngIf="isEdicao && !isProprioUsuario" style="margin-bottom: 20px">
      <button mat-stroked-button color="primary" type="button" [class.destaque-papel]="destacarBotaoPapel" (click)="adicionarPapel()" [disabled]="!form.get('papel')?.value || salvando" aria-label="Adicionar papel ao usuário">
        <mat-icon>add</mat-icon> Adicionar Papel
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close [disabled]="salvando" aria-label="Cancelar">Cancelar</button>
  <button mat-raised-button color="primary" (click)="salvar()" [disabled]="salvando || isProprioUsuario" aria-label="Salvar usuário">
    <mat-icon *ngIf="salvando" class="spin">sync</mat-icon>
    {{ isEdicao ? 'Atualizar' : 'Criar' }}
  </button>
</mat-dialog-actions>
